import abstractModel from "../../core/MercatelyModel";
import { MERCATELY_API } from '../../constants/AppConstants';

const csrfToken = document.querySelector('[name=csrf-token]').content;

const resource = `${MERCATELY_API}`;
const model = abstractModel(resource);

const parentSave = model.save;

model.getInfo = async () => {
  const newResource = `${resource}/retailer_info`;

  return model.get({}, { path: newResource });
};

model.updateTermsCondition = async (id, terms_conditions_content) => {
  const newResource = `${resource}/update_terms_condition`;

  return parentSave(
    { retailer_terms_conditions: { id, terms_conditions_content } },
    { path: newResource, csrfToken }
  );
};

model.toggleOrAddMiaPlatform = async (params) => {
  const newResource = `${resource}/toggle_or_add_mia_platforms`;

  return model.save(params, { path: newResource, csrfToken });
};

model.toggleSyncMiaProduct = async (params) => {
  const newResource = `${resource}/toggle_sync_mia_product`;

  return model.save(params, { path: newResource, csrfToken });
};

model.sync_mia_products = async (params) => {
  const newResource = `${resource}/sync_mia_products`;

  return model.save(params, { path: newResource, csrfToken })
};

model.miaSyncSelectedProducts = async (params) => {
  const newResource = `${resource}/mia_sync_selected_products`;

  return model.save(params, { path: newResource, csrfToken })
};

model.getGeneralInfo = async () => {
  const newResource = `${resource}/retailer_general_info`;

  return model.get({}, { path: newResource });
};

model.getTimezones = async () => {
  const newResource = `${resource}/timezones`;

  return model.get({}, { path: newResource });
};

model.updateGeneralInfo = async (formData) => {
  const newResource = `${resource}/update_general_info`;

  return model.put(formData, { path: newResource, csrfToken });
};

model.getDomain = async () => {
  const newResource = `${resource}/retailer_domain`;

  return model.get({}, { path: newResource });
};

model.setDomain = async (formData) => {
  const newResource = `${resource}/set_domain`;

  return model.put(formData, { path: newResource, csrfToken });
};

model.getSchedules = async () => {
  const newResource = `${resource}/retailer_schedules`;

  return model.get({}, { path: newResource });
};

model.updateSchedules = async (params) => {
  const newResource = `${resource}/update_schedules`;

  return model.put(params, { path: newResource, csrfToken });
};

model.getContacts = async () => {
  const newResource = `${resource}/retailer_contacts`;

  return model.get({}, { path: newResource });
};

model.updateContacts = async (params) => {
  const newResource = `${resource}/update_contacts`;

  return model.put(params, { path: newResource, csrfToken });
};

export default model;
